import React, {useContext, useEffect} from 'react';
import useStyles from "./styles";
import { FormGroup, FormHelperText, Grid, InputBase } from "@material-ui/core";
import Index from "../StripeInput";
import PostalCode from "../PostalCode";
import { CARD_OPTIONS } from "../../constants";
import { useTranslation } from 'react-i18next';
import stripErrors from '../../utils/stripErrors';
import {CheckoutComFramesReady} from "../../App";
import {CardNumber, Cvv, ExpiryDate} from "frames-react";
import { CardElement as EvyCardElement } from './CardElement';
import {isValid, isExpirationDateValid} from "creditcard.js";
import {checkoutComEvents} from "../../events/checkoutCom.events";
import {transformToYYYY} from "../../utils";

const Card = ({ formik }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const cardHandler = ({ value, element, completed = false }) => {
    let payload = {}
    let isElementValid = false

    const {error, ...values} = formik.values[element];
    formik.setFieldValue(element, {
      ...values,
      error: null,
    });

    switch (element) {
      case 'cardNumber': {
          const cardNumber = value.replace(/\s/g, '');
          isElementValid = isValid(cardNumber) && cardNumber.length >= 16;

          payload = {
            element: 'card-number',
            isEmpty: cardNumber.length === 0,
            isValid: isElementValid,
            value
          }
          break;
      }
        case 'cardExpiry': {
            const cardExpiry = value.split('/');
            isElementValid = isExpirationDateValid(...cardExpiry);

            const month = cardExpiry[0];

            if(month && month.length === 2) {
                if(parseInt(month) > 12) {
                    cardExpiry[0] = '12';
                }
            }

            payload = {
                element: 'expiry-date',
                isEmpty: cardExpiry.length === 0,
                isValid: isElementValid,
                value: cardExpiry.join('/'),
            }
            break;
        }
        case 'cardCvc': {
            const cardCvc = value;
            isElementValid = (/^\d{3}$/).test(cardCvc);

            payload = {
                element: 'cvv',
                isEmpty: cardCvc.length === 0,
                isValid: isElementValid,
                value: cardCvc,
            }
            break;
        }
    }
    checkoutComEvents.emit('onValidationChanged', payload);

    if (completed && isElementValid) {
        switch (element) {
            case 'cardNumber': {
                document.querySelectorAll('.cardExpiry')[0]?.focus()
                break;
            }
            case 'cardExpiry': {
                document.querySelectorAll('.cardCvc')[0]?.focus()
                break;
            }
            case 'cardCvc': {
                document.querySelectorAll('.cardName')[0]?.focus()
                break;
            }
        }
    }
  }

  return (<div className={classes.cardWrapper}>
    <FormGroup className={classes.cardForm}>
      <p className={`${classes.cardText} input_label_text`}>{t('Card_number')} ({t('Card_number_ru_info')})</p>
      <InputBase
        error={!!(formik.values.cardNumber?.error)}
        label={t('Card_Number')}
        className={classes.inputBase}
        name={"cardNumber"}
        onChange={cardHandler}
        value={formik.values.cardNumber}
        variant="outlined"
        required
        fullWidth
        inputComponent={Index}
        inputProps={{
          component: EvyCardElement,
          options: {
            ...CARD_OPTIONS,
            mask: '____ ____ ____ ____',
            placeholder: '1234 1234 1234 1234',
            className: 'cardNumber'
          }
        }}
      />
      <FormHelperText className='error_text' error>{stripErrors(formik.values.cardNumber?.error?.message)}</FormHelperText>
    </FormGroup>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <FormGroup className={classes.cardForm}>
          <p className={`${classes.cardText} input_label_text`}>{t('Expiry_date')}</p>
          <InputBase
            error={!!(formik.values.cardExpiry?.error)}
            label={t('Expiry_date')}
            placeholder={t('card_expiry_placeholder')}
            name="cardExpiry"
            className={classes.inputBase}
            variant="outlined"
            required
            fullWidth
            onChange={cardHandler}
            value={formik.values.cardExpiry}
            inputComponent={Index}
            inputProps={{
              component: EvyCardElement,
              options: {
                ...CARD_OPTIONS,
                mask: '__/__',
                placeholder: t('card_expiry_placeholder'),
                className: 'cardExpiry'
              }
            }}
          />
          <FormHelperText className='error_text' error>{stripErrors(formik.values.cardExpiry?.error?.message)}</FormHelperText>
        </FormGroup>
      </Grid>
      <Grid item xs={6}>
        <FormGroup className={classes.cardForm}>
          <p className={`${classes.cardText} input_label_text`}>{t('CVC')}</p>
          <InputBase
            error={!!(formik.values.cardCvc?.error)}
            label="CVC"
            className={classes.inputBase}
            name="cardCvc"
            variant="outlined"
            required
            fullWidth
            onChange={cardHandler}
            value={formik.values.cardCvc}
            inputComponent={Index}
            inputProps={{
                component: EvyCardElement,
                options: {
                    ...CARD_OPTIONS,
                    mask: '___',
                    placeholder: 'CVC',
                    className: 'cardCvc'
                }
            }}
          />
          <FormHelperText className='error_text' error>{formik.values.cardCvc?.error?.message}</FormHelperText>
        </FormGroup>
      </Grid>
    </Grid>
    <FormGroup className={classes.cardForm}>
      <p className={`${classes.cardText} input_label_text`}>{t('Name_on_Card')}</p>
      <InputBase
        error={!!(formik.errors?.cardName && formik.touched?.cardName)}
        placeholder={t('Name_on_Card')}
        label={t('Name_on_Card')}
        name="cardName"
        value={formik.values.cardName?.toUpperCase()}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        variant="outlined"
        required
        fullWidth
        inputProps={{
          maxLength: 100,
        }}
      />
      {
        formik.errors?.cardName && formik.touched?.cardName && (
          <FormHelperText className='error_text' error>{formik.errors?.cardName}</FormHelperText>
        )
      }
    </FormGroup>
    <PostalCode formik={formik} className={`${classes.cardForm} input_label_text`} />
  </div>)
}

export default Card;
